import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://occultking.com';
const SITE_NAME = 'OccultKing';
const DEFAULT_IMAGE = `${SITE_URL}/occult_king_logo_new.png`;

const SEO_DATA = {
  '/': {
    title: 'OccultKing - #1 Free Vastu Gridding Software | Best Vastu Map Griding Tool Online',
    description: 'OccultKing is the best free Vastu gridding software. Professional Vastu map griding, 45 Devtas analysis, 16 zones Vastu grid, Vastu Purush Mandala, KP Astrology, Numerology & Kundli. All-in-One Vastu + Astrology + Numerology software by Acharya Vikul Bansal. Try free!',
    keywords: 'vastu gridding software, free vastu software, best vastu tool, vastu map griding tool, 45 devtas vastu software, vastu purush mandala software, online vastu tool, vastu grid analysis, vastu consultant software, astro vastu tool, numerology software, kundli software, free vastu analysis software, vastu software india, free online vastu grid tool, kp astrology software, OccultKing, Pinnacle Vastu Software, Acharya Vikul Bansal',
  },
  '/vastu-software': {
    title: 'Best Free Vastu Gridding Software Online | Professional Vastu Map Griding Tool - OccultKing',
    description: 'The most advanced free Vastu gridding software online. Professional map griding, 45 Devtas overlay, 16 zones analysis, automatic Vastu grid generator, Vastu dosha detection, premium PDF reports. Best Vastu software for consultants in India. Try free!',
    keywords: 'vastu software, free vastu gridding software, best vastu software online, vastu map griding tool, vastu consultant software, professional vastu tool, 16 zones vastu grid software, 45 devtas chart analysis software, vastu bar chart analysis tool, automatic vastu grid generator, vastu dosha detection software, free vastu software india, vastu analysis software, vastu chart analysis tool',
  },
  '/astro-vastu': {
    title: 'Free Astro Vastu Software | Vastu Gridding with Kundli & KP Astrology - OccultKing',
    description: 'Best free Astro Vastu software combining Vastu gridding with KP Astrology & Kundli integration. Professional astro vastu analysis, 45 Devtas mapping, personalized remedies & premium reports. Complete Astro-Vastu solution for accurate predictions.',
    keywords: 'astro vastu software, free astro vastu software, vastu with kundli, kp astrology software, kp astrology analysis tool, astro vastu tool, vastu gridding astrology, kundli vastu analysis, free kp astrology software, astro vastu software india, kp astrology india software, vastu + astrology software',
  },
  '/45-devtas-vastu': {
    title: '45 Devtas Vastu Analysis Software Free | Complete Devta Energy Mapping - OccultKing',
    description: 'Advanced free 45 Devtas Vastu analysis software. Map all 45 Devtas on your floor plan, understand their energies, Vastu Purush Mandala analysis, food remedies, 3D remedies & personalized recommendations. Professional 45 Devtas chart analysis tool.',
    keywords: '45 devtas vastu software, 45 devtas chart analysis software, devta analysis software, vastu devta mapping, 45 devtas energy, vastu purush mandala devtas, devta remedies, free 45 devtas analysis, software for vastu map analysis with 45 devtas',
  },
  '/numerology': {
    title: 'Free Numerology Calculator Online | Lo Shu Grid, Life Path & Name Number - OccultKing',
    description: 'Free online Numerology calculator with Lo Shu Grid analysis, Life Path number, Destiny number, missing number remedies, crystal bracelet recommendations & 3-year predictions. Best free numerology report generator with remedies.',
    keywords: 'free numerology calculator online, numerology report generator, lo shu grid, free numerology, vedic numerology, name numerology, missing number remedies, numerology software, free numerology report generator with remedies, online numerology calculator, numerology software india',
  },
  '/vastu-consultation': {
    title: 'Online Vastu Consultation | Expert Vastu Advice by Acharya Vikul Bansal - OccultKing',
    description: 'Book online Vastu consultation with Acharya Vikul Bansal. Expert 45 Devtas analysis, Vastu Purush Mandala review, personalized remedies, professional Vastu consultation tools. 25+ years experience.',
    keywords: 'online vastu consultation, vastu consultant, vastu expert, vastu advice online, book vastu consultation, professional vastu consultation tools, vastu consultation software, vastu consultant tools india',
  },
  '/vastu-course': {
    title: 'Professional Vastu Course Online | Learn 45 Devtas & Map Griding - OccultKing',
    description: 'Learn professional Vastu Shastra with our comprehensive online course. Master 45 Devtas, 16 zones, Vastu map griding, Vastu Purush Mandala & become a certified Vastu consultant. Best Vastu course by Acharya Vikul Bansal.',
    keywords: 'vastu course, learn vastu online, professional vastu course, vastu shastra course, vastu certification, vastu training, vastu course india',
  },
  '/consultation': {
    title: 'Book Vastu & Astrology Consultation | Personal Expert Guidance - OccultKing',
    description: 'Get personal Vastu and Astrology consultation. Expert guidance for home, office, business using Vastu gridding, 45 Devtas analysis, KP Astrology & Kundli integration.',
    keywords: 'vastu consultation booking, astrology consultation, personal vastu advice, vastu for home, vastu for office, vastu consultation software',
  },
  '/go-premium': {
    title: 'OccultKing Premium | Unlimited Vastu Reports, KP Astrology & Advanced Tools',
    description: 'Upgrade to OccultKing Premium for unlimited Vastu reports, white-label branding, advanced Astro Vastu tools, KP Astrology analysis, Occult Manager, and priority support. Best Vastu software for professionals.',
    keywords: 'occultking premium, vastu software premium, unlimited vastu reports, vastu consultant tools, white label vastu, vastu software for professionals',
  },
  '/remedies': {
    title: 'Vastu Remedies & 3D Products | Authentic Vastu Solutions - OccultKing',
    description: 'Shop authentic Vastu remedies and 3D products. Brass idols, Yantras, crystals, paintings recommended in your Vastu analysis report. Vastu remedies software recommendations.',
    keywords: 'vastu remedies, vastu products, brass vastu items, vastu 3d remedies, vastu crystals, vastu paintings, vastu remedies software',
  },
  '/pinnacle-guru': {
    title: 'Free AI Vastu & Astrology Guru | Ask Questions & Get Expert Answers - OccultKing',
    description: 'Chat with our free AI-powered Vastu and Astrology guru. Get instant answers to your Vastu, Numerology & Astrology questions based on ancient Vedic wisdom. Ask OK by Acharya Vikul Bansal.',
    keywords: 'ai vastu guru, vastu chatbot, ask vastu questions, vastu ai, astrology ai, numerology ai, free vastu consultation, Ask OK, Pinnacle Guru',
  },
  '/acharya-vikul-bansal': {
    title: 'Acharya Vikul Bansal | Expert Vastu Consultant & Astrologer | Pinnacle Vastu - OccultKing',
    description: 'Meet Acharya Vikul Bansal, founder of OccultKing & Pinnacle Vastu. 25+ years in Vastu Shastra, Astro Vastu, 45 Devtas analysis, KP Astrology. Creator of best Vastu gridding software. Book personal consultation today.',
    keywords: 'acharya vikul bansal, vastu expert, vastu consultant india, astro vastu expert, pinnacle vastu founder, Acharya Vikul Bansal Vastu Software, Pinnacle Vastu Solutions',
  },
  '/blog': {
    title: 'Vastu Shastra Blog | Tips, Guides & Expert Articles - OccultKing',
    description: 'Read expert Vastu Shastra articles, tips & guides. Learn about 45 Devtas, 16 zones, Vastu remedies, kitchen Vastu, bedroom Vastu & more. Free Vastu knowledge by Acharya Vikul Bansal.',
    keywords: 'vastu blog, vastu tips, vastu guides, vastu shastra articles, vastu remedies tips, vastu for home tips',
  },
  '/tutorials': {
    title: 'Vastu Video Tutorials | Learn Vastu Gridding & Analysis Free - OccultKing',
    description: 'Watch free Vastu tutorials by Acharya Vikul Bansal. Learn Vastu map griding, 45 Devtas analysis, report generation & more using OccultKing software.',
    keywords: 'vastu tutorials, vastu video lessons, learn vastu gridding, vastu software tutorial, vastu course videos, free vastu learning',
  },
  '/free-vastu-software': {
    title: 'Free Vastu Gridding Software Online | #1 Vastu Map Analysis Tool - OccultKing',
    description: 'Get the best free Vastu gridding software online. Create Vastu grids in 1 click, 45 Devtas analysis, 16 zones mapping, Vastu dosha detection, automatic grid generator, bar chart analysis. Free Vastu software for home analysis. No download needed!',
    keywords: 'free vastu gridding software, free vastu analysis software, free online vastu grid tool, free vastu map gridding tool, free vastu software india, free vastu grid calculator online, best free vastu gridding software for consultants, free online vastu grid calculator with 45 devtas, free vastu software with bar chart analysis, free vastu map analysis tool for home, free vastu dosha analysis software, free vastu grid generator online india, free 16 zones vastu grid software, free 45 devtas chart analysis software, free automatic vastu grid generator, free vastu direction analysis software',
  },
  '/kp-astrology-software': {
    title: 'Free KP Astrology Software Online | KP Prediction & Analysis Tool - OccultKing',
    description: 'Best free KP Astrology software with prediction system. Advanced KP astrology analysis tool, Kundli integration, Vastu compatibility, personalized predictions & remedies. Free KP astrology calculator online India.',
    keywords: 'kp astrology software, free kp astrology software, kp astrology analysis tool, kp astrology prediction software, free kp astrology calculator, kp astrology india software, kp astrology software with prediction system, free kp astrology prediction software online, advanced kp astrology vastu software for consultants',
  },
  '/free-numerology-calculator': {
    title: 'Free Numerology Calculator & Report Generator | Lo Shu Grid Analysis - OccultKing',
    description: 'Free online numerology calculator and report generator with remedies. Lo Shu Grid analysis, Life Path, Destiny & Name Number calculation, missing number remedies, crystal recommendations, 3-year predictions. Best free numerology software India.',
    keywords: 'free numerology calculator online, free numerology report generator, free numerology report generator with remedies, numerology calculator, lo shu grid calculator, free numerology software india, online numerology calculator, free numerology reading, vedic numerology calculator',
  },
  '/vastu-report': {
    title: 'Premium Vastu Report Generator | Detailed 45 Devtas Analysis PDF - OccultKing',
    description: 'Generate professional premium Vastu reports with detailed 45 Devtas analysis, 16 zones mapping, Vastu dosha identification, personalized remedies, bar chart analysis. White-label PDF reports for Vastu consultants.',
    keywords: 'vastu report generator, premium vastu report, vastu analysis report, vastu pdf report, 45 devtas report, vastu consultant report, vastu software for professionals',
  },
  '/astro-report': {
    title: 'Premium Astrology Report | KP Astrology & Kundli Analysis - OccultKing',
    description: 'Generate premium Astrology reports with KP Astrology analysis, Kundli charts, planetary positions, Dasha predictions, personalized remedies. Professional astrology report generator.',
    keywords: 'astrology report, premium astrology report, kp astrology report, kundli report, astrology analysis, astro report generator',
  },
  '/numerology-report': {
    title: 'Premium Numerology Report | Detailed Lo Shu Grid & Prediction Report - OccultKing',
    description: 'Generate premium Numerology reports with detailed Lo Shu Grid analysis, Name & Date number analysis, missing number remedies, crystal recommendations, 3-year predictions. Professional numerology report generator.',
    keywords: 'numerology report, premium numerology report, lo shu grid report, numerology analysis report, numerology prediction report',
  },
  '/vastu-calculators': {
    title: 'Free Vastu Calculators Online | Tao Aay & Energy Analysis Tools - OccultKing',
    description: 'Free online Vastu calculators including Tao Aay calculator, Vastu energy analysis, direction analysis tools. Professional Vastu calculation tools for consultants and home owners.',
    keywords: 'vastu calculator, free vastu calculator, tao aay calculator, vastu energy calculator, vastu direction calculator, vastu analysis tool free',
  },
  '/tao-aay-calculator': {
    title: 'Free Tao Aay Calculator Online | Vastu Tao Aay Analysis - OccultKing',
    description: 'Free online Tao Aay calculator for Vastu analysis. Calculate Tao and Aay for any building or plot. Professional Vastu tool by Acharya Vikul Bansal.',
    keywords: 'tao aay calculator, free tao aay calculator, vastu tao aay, tao aay analysis, vastu calculator online',
  },
  '/install': {
    title: 'Install OccultKing App | Free Vastu & Astrology Software PWA - OccultKing',
    description: 'Install OccultKing progressive web app on your phone or desktop. Free Vastu gridding software, Numerology calculator, KP Astrology tools — works offline. No app store needed.',
    keywords: 'install occultking app, vastu app download, vastu software app, occultking pwa, free vastu app',
  },
  '/get-app': {
    title: 'Get OccultKing App | Download Free Vastu Software - OccultKing',
    description: 'Download the OccultKing app for free. Professional Vastu gridding, Numerology calculator, KP Astrology & Kundli tools on your device. Works on Android, iOS & Desktop.',
    keywords: 'get occultking app, download vastu app, vastu software download, free vastu app android, occultking download',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | OccultKing - Vastu & Astrology Software',
    description: 'Read OccultKing privacy policy. Learn how we collect, use and protect your personal data on our Vastu gridding, Astrology and Numerology software platform.',
    keywords: 'occultking privacy policy, vastu software privacy, data protection policy',
  },
  '/terms': {
    title: 'Terms & Conditions | OccultKing - Vastu & Astrology Software',
    description: 'OccultKing terms and conditions for using our Vastu gridding software, Astrology tools, Numerology calculator and premium services.',
    keywords: 'occultking terms, vastu software terms, terms of service',
  },
  '/refund-policy': {
    title: 'Refund & Cancellation Policy | OccultKing Premium',
    description: 'OccultKing refund and cancellation policy for premium subscriptions, Vastu reports, Astrology reports and consultation services.',
    keywords: 'occultking refund policy, vastu software refund, cancellation policy',
  },

  // ============================================================
  // PREMIUM REPORT LANDING PAGES (₹527 personalised PDFs)
  // ============================================================
  '/mahakundli': {
    title: 'Mahakundli Report — 50+ Page Personalised Vedic Kundli PDF | Occult King',
    description: 'The most detailed personalised Vedic astrology report online — 50+ pages, 16 sections, lifetime Mahadasha + Antardasha timing, 12 house predictions, doshas, transits and personalised remedies. Written for your exact birth chart. Delivered on WhatsApp + Email in 90 seconds. ₹527.',
    keywords: 'mahakundli, mahakundli report, online kundli report, premium kundli pdf, detailed kundli online, personalised vedic kundli, 50 page kundli report, janam kundli pdf, mahadasha report, antardasha timing, kundli in hindi, kundli analysis report, vedic astrology report online, lifetime kundli predictions, free kundli vs paid kundli, parashari kundli report, kp kundli, kundli with remedies, kundli for marriage, kundli for career, occultking mahakundli, acharya vikul bansal kundli',
  },
  '/lalkitab': {
    title: 'Lal Kitab Report — 40+ Page Personalised Lal Kitab Kundli & Remedies | Occult King',
    description: 'Premium Lal Kitab report — Pandit Roop Chand Joshi tradition. 40+ pages of Lal Kitab Kundli, Teva, Varshphal, Karz analysis, planetary debts and household totka remedies. Personalised to your chart. WhatsApp + Email delivery in 90 seconds. ₹527.',
    keywords: 'lal kitab, lal kitab report, lal kitab kundli, lal kitab teva, lal kitab varshphal, lal kitab remedies, lal kitab in hindi, lal kitab totka, lal kitab karz, lal kitab debts, pandit roop chand joshi, free lal kitab kundli, premium lal kitab report pdf, lal kitab predictions, lal kitab dosh, lal kitab horoscope, online lal kitab, lal kitab kundli with remedies, occultking lal kitab, lal kitab pdf download',
  },
  '/bnn': {
    title: 'BNN Report — 50+ Page Bhrigu Nandi Nadi Astrology PDF | Occult King',
    description: 'Bhrigu Nandi Nadi (R. G. Rao tradition) premium report — 50+ pages of exact-year predictions for marriage, money & career. Karaka conjunctions, Bhrigu Bindu activation timeline, transit hits, personalised remedies. No Dasha guessing. WhatsApp + Email delivery in 90 seconds. ₹527.',
    keywords: 'bnn, bnn report, bhrigu nandi nadi, bhrigu nandi nadi astrology, bhrigu nandi nadi pdf, r g rao bnn, bnn karaka conjunctions, bhrigu bindu, bhrigu bindu calculator, bnn predictions, nadi astrology report, bnn kundli online, bhrigu nadi report, premium nadi astrology pdf, exact year predictions astrology, nadi astrology marriage timing, nadi astrology career predictions, occultking bnn, bnn report in hindi, bhrigu samhita online',
  },
  '/raj-yog': {
    title: 'Raj Yog Report — Every Raja Yoga + Activation Map | Occult King',
    description: 'Premium Raj Yog Report — scans your chart for 30+ classical Raj Yogas (Pancha Mahapurusha, Kendra-Trikona, Vipreet, Dhana, Gajakesari, Neecha Bhanga). 50+ pages with the exact Mahadasha + transit windows when each yoga activates. WhatsApp + Email delivery. ₹527.',
    keywords: 'raj yog report, raja yoga report, raj yog kundli, raj yoga in kundli, pancha mahapurusha yoga, kendra trikona raj yoga, vipreet raja yoga, dhana yoga, gajakesari yoga, budha aditya yoga, neecha bhanga raj yoga, akhanda samrajya yoga, raja yoga activation, raja yoga timing, raja yoga calculator online, premium raj yoga pdf, yoga in vedic astrology, classical raja yogas, occultking raj yog, raj yog report in hindi',
  },
  '/life-report': {
    title: 'Life Report — 25-Page Personalised Life Roadmap PDF | Occult King',
    description: 'Plain-English personalised Life Roadmap from your birth chart — 11 chapters, ~25 pages. 12-month forecast, 5-year roadmap, 15-year Mahadasha big-picture, time-anchored remedies (daily/weekly/monthly). No Sanskrit jargon. WhatsApp + Email delivery in 90 seconds. ₹527.',
    keywords: 'life report, life roadmap astrology, personalised astrology report, vedic life report pdf, life prediction report, 12 month forecast astrology, 5 year astrology forecast, life path astrology report, plain english astrology report, astrology report in hindi, my life report kundli, vedic life prediction online, lifetime forecast astrology, premium life report pdf, occultking life report, life report with remedies, astrology gift for teenager, parents gift astrology report, astrology life biography',
  },
};

// ============================================================
// JSON-LD Structured Data Generators
// ============================================================

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "OccultKing by Pinnacle Vastu",
  "alternateName": ["Pinnacle Vastu Software", "Pinnacle Vastu Solutions", "Pinnacle Astro Vastu Tool"],
  "url": SITE_URL,
  "logo": `${SITE_URL}/occult_king_logo_new.png`,
  "description": "All-in-One Vastu + Astrology + Numerology Software. Professional Vastu Gridding Software with 45 Devtas Analysis by Acharya Vikul Bansal.",
  "founder": {
    "@type": "Person",
    "name": "Acharya Vikul Bansal",
    "jobTitle": "Vastu Expert & Astrologer",
    "description": "25+ years experience in Vastu Shastra, Astro Vastu, KP Astrology. Creator of OccultKing - best Vastu gridding software."
  },
  "sameAs": [
    "https://www.instagram.com/pinnaclevastu/",
    "https://www.youtube.com/@pinnaclevastu",
    "https://www.facebook.com/pinnaclevastu"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "availableLanguage": ["English", "Hindi"]
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  }
});

export const generateWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OccultKing",
  "alternateName": "Pinnacle Vastu Software",
  "url": SITE_URL,
  "description": "Best free Vastu gridding software, KP Astrology, Numerology calculator & Kundli tool online.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${SITE_URL}/blog?q={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
});

export const generateSoftwareSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "OccultKing - Vastu Gridding Software",
  "applicationCategory": "UtilitiesApplication",
  "operatingSystem": "Web Browser, Android, iOS",
  "description": "Professional Vastu Gridding Software with 45 Devtas Analysis, 16 Zones Mapping, KP Astrology, Numerology Calculator & Kundli. All-in-one Astro-Vastu solution.",
  "url": SITE_URL,
  "image": `${SITE_URL}/occult_king_logo_new.png`,
  "author": {
    "@type": "Person",
    "name": "Acharya Vikul Bansal"
  },
  "offers": [
    {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "INR",
      "name": "Free Plan",
      "description": "Free Vastu gridding, Numerology calculator, basic reports"
    },
    {
      "@type": "Offer",
      "price": "499",
      "priceCurrency": "INR",
      "name": "Premium Monthly",
      "description": "Unlimited Vastu reports, advanced analysis, white-label branding, Occult Manager"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "850",
    "bestRating": "5"
  },
  "featureList": [
    "Vastu Map Gridding with 45 Devtas",
    "16 Zones Vastu Analysis",
    "Automatic Vastu Grid Generator",
    "Vastu Dosha Detection",
    "Vastu Bar Chart Analysis",
    "Vastu Direction Analysis",
    "Vastu Energy Analysis",
    "KP Astrology Software",
    "Free Numerology Calculator with Lo Shu Grid",
    "Premium PDF Report Generator",
    "Vastu Remedies with 3D Images",
    "AI Vastu Guru Chatbot",
    "Occult Manager for Consultants",
    "White-Label Reports"
  ]
});

export const generatePersonSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Acharya Vikul Bansal",
  "jobTitle": "Vastu Expert, Astrologer & Software Creator",
  "description": "Founder of OccultKing & Pinnacle Vastu. 25+ years experience in Vastu Shastra, Astro Vastu, KP Astrology, 45 Devtas Analysis. Creator of best Vastu gridding software in India.",
  "url": `${SITE_URL}/acharya-vikul-bansal`,
  "image": `${SITE_URL}/occult_king_logo_new.png`,
  "worksFor": {
    "@type": "Organization",
    "name": "Pinnacle Vastu Solutions"
  },
  "knowsAbout": ["Vastu Shastra", "Astro Vastu", "KP Astrology", "Numerology", "45 Devtas Analysis", "Vastu Purush Mandala"]
});

export const generateCourseSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Course",
  "name": "Professional Vastu Course by Acharya Vikul Bansal",
  "description": "Learn professional Vastu Shastra with 45 Devtas analysis, 16 zones mapping, Vastu map griding, Vastu Purush Mandala & become a certified Vastu consultant.",
  "provider": {
    "@type": "Organization",
    "name": "OccultKing by Pinnacle Vastu",
    "url": SITE_URL
  },
  "url": `${SITE_URL}/vastu-course`,
  "educationalLevel": "Professional",
  "inLanguage": ["en", "hi"],
  "isAccessibleForFree": false
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "name": item.name,
    "item": item.url,
  })),
});

export const generateArticleSchema = ({ title, description, url, image, datePublished, dateModified, author }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": title,
  "description": description,
  "url": url,
  "image": image || DEFAULT_IMAGE,
  "datePublished": datePublished,
  "dateModified": dateModified || datePublished,
  "author": { "@type": "Person", "name": author || "Acharya Vikul Bansal" },
  "publisher": { "@type": "Organization", "name": SITE_NAME, "logo": { "@type": "ImageObject", "url": DEFAULT_IMAGE } },
});

/**
 * Schema.org Product schema for premium personalised reports.
 * Used by Mahakundli, Lal Kitab, BNN, Raj Yog, Life Report landing pages.
 *
 * @param {object} opts
 * @param {string} opts.name           e.g. "Mahakundli Report"
 * @param {string} opts.description    Marketing-grade product description.
 * @param {string} opts.url            Canonical landing-page URL.
 * @param {string} opts.image          Hero/cover image URL (absolute).
 * @param {string|number} opts.price   e.g. "527"
 * @param {string} opts.priceCurrency  e.g. "INR"
 * @param {string} opts.ratingValue    e.g. "4.8"
 * @param {string|number} opts.ratingCount  e.g. 5200
 * @param {string} [opts.sku]          e.g. "mahakundli-v1"
 */
export const generateReportProductSchema = ({
  name,
  description,
  url,
  image,
  price,
  priceCurrency = "INR",
  ratingValue = "4.8",
  ratingCount = 1500,
  sku,
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": name,
  "description": description,
  "url": url,
  "image": image || DEFAULT_IMAGE,
  "sku": sku || name.toLowerCase().replace(/\s+/g, "-"),
  "brand": {
    "@type": "Brand",
    "name": "Occult King",
  },
  "category": "Astrology Report",
  "offers": {
    "@type": "Offer",
    "url": url,
    "price": String(price),
    "priceCurrency": priceCurrency,
    "availability": "https://schema.org/InStock",
    "priceValidUntil": "2027-12-31",
    "seller": {
      "@type": "Organization",
      "name": "OccultKing by Pinnacle Vastu",
    },
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": String(ratingValue),
    "ratingCount": String(ratingCount),
    "bestRating": "5",
    "worstRating": "1",
  },
});

// ============================================================
// Main SEO Component
// ============================================================

const SEO = ({ title, description, keywords, canonicalUrl, path, image, structuredData }) => {
  const data = path ? (SEO_DATA[path] || SEO_DATA['/']) : {};
  const finalTitle = title || data.title || SEO_DATA['/'].title;
  const finalDesc = description || data.description || SEO_DATA['/'].description;
  const finalKeywords = keywords || data.keywords || SEO_DATA['/'].keywords;
  const finalUrl = canonicalUrl || (path ? `${SITE_URL}${path === '/' ? '' : path}` : SITE_URL);
  const finalImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={finalUrl} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:url" content={finalUrl} />
      <meta name="twitter:image" content={finalImage} />
      
      {/* Geo targeting for India */}
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <meta name="ICBM" content="20.5937, 78.9629" />
      
      {/* Language */}
      <meta httpEquiv="content-language" content="en-IN" />
      <link rel="alternate" hrefLang="en-in" href={finalUrl} />
      <link rel="alternate" hrefLang="en" href={finalUrl} />
      
      {/* Structured Data (single object or array of JSON-LD schemas) */}
      {structuredData && (
        Array.isArray(structuredData)
          ? structuredData.map((schema, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            ))
          : <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
export { SEO_DATA, SITE_URL, SITE_NAME, DEFAULT_IMAGE };
